import React from 'react';
import styled from '@emotion/styled';

import { Log } from '@common/log-manager';
import { UxGoodsCardItemForVerticalProductCard, VerticalProductCardGridContainer } from '@common/product-card';

import { useProductCardEvents } from '../../hooks/useProductCardEvents';

export interface StoreHomeVerticalProductCardListProps {
  item_list: UxGoodsCardItemForVerticalProductCard[];
  log?: Partial<Log>;
  useImpression?: boolean;
  columnCount?: 2 | 3;
  size?: 'small' | 'medium' | 'large';
}

export const StoreHomeVerticalProductCardList: React.FC<
  React.PropsWithChildren<StoreHomeVerticalProductCardListProps>
> = (props) => {
  const { log, useImpression } = props;
  const { onClick, onImpression, onLikeClick } = useProductCardEvents();

  const handleProductReveal = (item: UxGoodsCardItemForVerticalProductCard, index: number) => {
    if (log != null && useImpression) {
      onImpression(item, index, log);
    }
  };

  return (
    <Wrapper>
      <VerticalProductCardGridContainer
        columnCount={props.columnCount ?? 3}
        defaultColumnCount={props.columnCount ?? 3}
        defaultSize={props.size ?? 'small'}
        items={props.item_list}
        onImpression={handleProductReveal}
        onClick={(item, index, event) => onClick(event, item, index, log)}
        onLikeClick={(isLiked, item, index) => onLikeClick(isLiked, item, index, log)}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding-bottom: 20px;
`;
